import placeholderImg from "assets/placeholder.png";
import _ from "lodash";
import { sortByCreatedAtDescending } from "./sorting/sortingFunctions";

export const fileToImgSrc = async (file) => {
  try {
    return await fileToDataUrl(file);
  } catch (err) {
    console.error("fileToImgSrc error", err);
    return placeholderImg;
  }
};

/**
 * Takes out filename, checks if it has more than one extension in the filename and strips them out
 * @param {*} filename
 * @returns name with only one extension. If argument string has no extension, returns the string back
 */
export function stripFilename(filename) {
  if (!(filename && typeof filename === "string" && filename.length > 0)) {
    return null;
  }
  let basename = "";
  let extension = filename.split(".").pop();
  const extensions = ["mp4", "jpeg", "jpg", "png", "mov"];
  const parts = filename.split(".");
  if (parts.length < 2) {
    return filename;
  }
  for (let i = 0; i < parts.length; i++) {
    if (!extensions.includes(parts[i].toLocaleLowerCase()) && i < parts.length - 1) {
      if (i > 0) basename += ".";
      basename += parts[i];
    }
  }

  return basename + `.${extension}`;
}

const fileToDataUrl = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => resolve(e.target.result);
    reader.onerror = (e) => reject(e);
    reader.readAsDataURL(file);
  });
};

export const replaceArrayItem = (array, when, newItem) => {
  for (let i = 0; i < array.length; i++) {
    if (when(array[i])) {
      const newArray = [...array.slice(0, i), newItem, ...array.slice(i + 1)];
      return newArray;
    }
  }
  return array;
};

export const flattenObject = (obj) => {
  const flattened = {};
  Object.keys(obj).forEach((key) => {
    const value = obj[key];

    if (typeof value === "object" && value !== null && !Array.isArray(value)) {
      Object.assign(flattened, flattenObject(value));
    } else {
      flattened[key] = value;
    }
  });
  return flattened;
};

export const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

/**
 * Update item in array if already exists or add it to array
 * @param {object[]} array                  - The array of items
 * @param {comparisonFunc} comparisonFunc   - Comparison function used to find item in array
 * @param {object} foundItem                - The item to add or update
 * @returns {boolean}
 */
export const addOrUpdateArrayItem = (array, comparisonFunc, foundItem) => {
  let newItems = [...array];
  if (foundItem) {
    const foundItemAlreadyLoaded = !!_.find(array, comparisonFunc);
    newItems = foundItemAlreadyLoaded
      ? replaceArrayItem(array, comparisonFunc, foundItem)
      : [foundItem, ...array].sort(sortByCreatedAtDescending);
  }
  return newItems;
};

/**
 * Comparison function
 * @callback comparisonFunc
 * @param {object} item
 */
